import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from 'src/hooks/use-auth';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';

function getSafeReturnTo() {
  const raw = new URLSearchParams(window.location.search).get('returnTo');
  if (!raw) {
    return null;
  }
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return null;
  }
  const lower = raw.toLowerCase();
  if (lower.includes('javascript:') || lower.includes('data:')) {
    return null;
  }
  return raw;
}

export const GuestGuard = (props) => {
  const { children } = props;
  const { isAuthenticated, isInitialized } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!isInitialized) {
      return;
    }
    if (isAuthenticated) {
      const returnTo = getSafeReturnTo();
      router.replace(returnTo || paths.setting.index);
    }
  }, [isAuthenticated, isInitialized, router]);

  if (!isInitialized) {
    return null;
  }

  if (isAuthenticated) {
    return null;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};
